module.exports = __webpack_public_path__ + "static/img/1.c017b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/1.jpg
// module id = zRwx
// module chunks = 1